import React from 'react';
import { useSelector } from 'react-redux';

import { getTranslation } from 'common/react/utils/translations';
import { selectCutoffs } from '../../selector/ladder';

/*
 * Ladder Table Legend
 */
export const LadderTableLegendFinals = () => {
    const cutOffPositions = useSelector(selectCutoffs);

    return (
        <div className="ladder-predictor-legend">
            <div className="ladder-predictor-legend__left">
                <dl className="ladder-predictor-legend__list">
                    {/* WF */}
                    {cutOffPositions?.secondCutOff ? (
                        <div className="ladder-predictor-legend__item-wrapper">
                            <dt className="ladder-predictor-legend__item ladder-predictor-legend__item--key">
                                {getTranslation(`label.ladder.wf.short`)}:
                            </dt>
                            <dd className="ladder-predictor-legend__item">
                                {getTranslation(`label.ladder.legend.wf`)}
                            </dd>
                        </div>
                    ) : null}

                    {/* QF */}
                    <div className="ladder-predictor-legend__item-wrapper">
                        <dt className="ladder-predictor-legend__item ladder-predictor-legend__item--key">
                            {getTranslation(`label.ladder.qf.short`)}:
                        </dt>

                        <dd className="ladder-predictor-legend__item">
                            {getTranslation(`label.ladder.legend.qf`)}
                        </dd>
                    </div>

                    {/* EF */}
                    <div className="ladder-predictor-legend__item-wrapper">
                        <dt className="ladder-predictor-legend__item ladder-predictor-legend__item--key">
                            {getTranslation(`label.ladder.ef.short`)}:
                        </dt>

                        <dd className="ladder-predictor-legend__item">
                            {getTranslation(`label.ladder.legend.ef`)}
                        </dd>
                    </div>

                    {/* SF */}
                    <div className="ladder-predictor-legend__item-wrapper">
                        <dt className="ladder-predictor-legend__item ladder-predictor-legend__item--key">
                            {getTranslation(`label.ladder.sf.short`)}:
                        </dt>
                        <dd className="ladder-predictor-legend__item">
                            {getTranslation(`label.ladder.legend.sf`)}
                        </dd>
                    </div>

                    {/* PF */}
                    <div className="ladder-predictor-legend__item-wrapper">
                        <dt className="ladder-predictor-legend__item ladder-predictor-legend__item--key">
                            {getTranslation(`label.ladder.pf.short`)}:
                        </dt>

                        <dd className="ladder-predictor-legend__item">
                            {getTranslation(`label.ladder.legend.pf`)}
                        </dd>
                    </div>

                    {/* GF */}
                    <div className="ladder-predictor-legend__item-wrapper">
                        <dt className="ladder-predictor-legend__item ladder-predictor-legend__item--key">
                            {getTranslation(`label.ladder.gf.short`)}:
                        </dt>
                        <dd className="ladder-predictor-legend__item">
                            {getTranslation(`label.ladder.legend.gf`)}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    );
};
